<!-- 库存记录跟踪详情-->
<template>
    <el-dialog :title="msg('订单记录')" :close-on-click-modal="false" 
        :visible.sync="visible" width="200"
        :fullscreen="isMinScreen"
    >
        <span><h3>快递单号：{{innetExpCode}}</h3></span>
        <el-row :gutter="15">
            <el-table :data="data" max-height="250" style="width: 100%" size="mini" ref="dataTable" stripe>
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="created" :label="msg('创建时间')" min-width="100" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="code" :label="msg('单号')" min-width="100" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="status" :label="msg('状态')" min-width="80" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-tag :type="dicts.stockStatus.find(d => d.value === scope.row.status).type" disable-transitions>
                            {{dicts.stockStatus.find(d => d.value === scope.row.status).label}}</el-tag>
                    </template>
                </el-table-column>   
                <el-table-column prop="shopDayToShip" :label="msg('最后出货时间')" min-width="100" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
        </el-row>
    </el-dialog>
    </template>
    
    <script>
    export default {
        name: 'InventoryInOrderTrace',
        comments: {
    
        },
        mounted: function(){
    
        },
        data(){
            return{
                visible: false,
                data:null,
                innetExpCode:null,
            }
        },
        computed: {
            isMinScreen: {  //是否小屏幕，浏览器
                get() {
                    var is = this.$store.state.isMinScreen;
                    return is;
                }
            },
        },
        methods: {
            showTracks(expCode){
                this.data = null;
                this.innetExpCode = expCode;
                this.$axios.post(this.$kit.api.inventoryIn.expCodeTraces+"?c="+expCode)
                    .then((result) => {
                        if(result.status){
                            this.data = result.data;
                            this.visible=true;
                        }else{
                            this.$message('无数据');
                        }
                    });
            }
        }
    }
    </script>
    
    <style lang="scss" scoped>
    .trace-wrap{display:flex; justify-content: space-between;}
    .trace-box{padding: 10px;}
    .detail{margin:10px;}
    .detail a{display:inline-block; margin-left: 8px;}
    </style>